import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Anything } from '@types';

export const useSupportContacts = (): string[] => {
	// keep this hook here to update when translations obtained
	useTranslation();
	const supportContactsResources = TranslationHelper.getByKey('eCommerce.supportContacts');
	const supportContacts: string[] = (supportContactsResources?.result as Anything) || [];
	return supportContacts;
};
